module.exports = __webpack_public_path__ + "img/person.a3cab8e3.png";